/** GET de etiquetas de cono en uso: números ocupados por color (amarillo/rojo), normalizados a `ConosEnUso`. */
import { API_ENDPOINTS } from "../apiEndpoints";
import { apiCall } from "../apiHelper";

export type ColorCono = "amarillo" | "rojo";
export type ConosEnUso = Record<ColorCono, number[]>;

const CONOS_VACIOS: ConosEnUso = { amarillo: [], rojo: [] };

const asegurarNumeros = (v: unknown): number[] =>
  Array.isArray(v)
    ? v
        .map((n) => Number(n))
        .filter((n) => Number.isInteger(n) && n > 0 && n <= 25)
    : [];

export const normalizarConosEnUso = (raw: unknown): ConosEnUso => {
  let data = raw;
  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch {
      return CONOS_VACIOS;
    }
  }
  if (Array.isArray(data)) {
    const res: ConosEnUso = { amarillo: [], rojo: [] };
    for (const itemRaw of data) {
      if (typeof itemRaw !== "object" || itemRaw === null) continue;
      const item = itemRaw as Record<string, unknown>;
      const color = String(item.color ?? "").toLowerCase();
      if (color === "amarillo" || color === "rojo") {
        res[color] = asegurarNumeros(item.numeros ?? item.numerosEnUso ?? []);
      }
    }
    return res;
  }
  if (typeof data === "object" && data !== null) {
    const obj = data as Record<string, unknown>;
    return {
      amarillo: asegurarNumeros(obj.amarillo),
      rojo: asegurarNumeros(obj.rojo),
    };
  }
  return CONOS_VACIOS;
};

export const GETConosEnUso = (codEmpresa?: string, codSucursal?: string) =>
  apiCall<ConosEnUso>({
    method: "get",
    url: `${API_ENDPOINTS.GET_CONOS_EN_USO}?codEmpresa=${codEmpresa || ""}&codSucursal=${codSucursal || ""}`,
  });